var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"md-accent",attrs:{"id":"app-footer"}},[_c('span',{staticStyle:{"margin-right":"1rem"}},[_vm._v("Made with ☕️ by\n    "),_c('a',{attrs:{"href":"https://github.com/tri613","target":"_blank","id":"app-footer-link"}},[_vm._v("Trina")]),_vm._v(", 2017.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501376bc","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 58
// module chunks = 2